import { Component, OnInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { ApiService } from './../services/api.service';

declare const $: any;

//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
    min_role?: string;
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
    page: string;
    min_role?: string;
    show_back_option?: boolean;
}

//Menu Items


export const ROUTES: RouteInfo[] = [{
    path: '/clientes',
    title: 'Clientes',
    type: 'sub',
    icontype: 'group',
    min_role: 'advisor',
    collapse: 'advisor',
    children: [
        { min_role: 'advisor', path: 'visualizar', title: 'Visualizar', ab: 'V', page: '' },
        { min_role: 'advisor', path: 'gerenciar', title: "Gerenciar", ab: "G", page: 'gerenciar_cliente', show_back_option: true }
    ]
}, {
    path: '/estudos',
    title: 'Estudos',
    type: 'sub',
    icontype: 'auto_stories',
    collapse: 'estudos',
    min_role: 'client',
    children: [
        { min_role: 'client', path: 'visualizar', title: 'Visualizar', ab: 'V', page: '' },
        { min_role: 'advisor', path: 'gerenciar', title: 'Gerenciar', ab: 'G', page: 'gerenciar_estudo', show_back_option: true },
        { min_role: 'advisor', path: 'recomendar', title: 'Recomendar', ab: 'R', page: 'recomendar_estudo', show_back_option: true },
    ]
}, {
    path: '/admin',
    title: 'Admin',
    type: 'sub',
    icontype: 'admin_panel_settings',
    collapse: 'admin',
    min_role: 'admin',
    children: [
        { min_role: 'admin', path: 'visualizar', title: 'Usuários', ab: 'U', page: '' },
    ]
}]

@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    router: any;


    constructor(_api: ApiService) { };

    // Método para acessar o valor de 'page' em localStorage
    getPageFromLocalStorage(): string {
        // Assegure-se de que localStorage está disponível
        try {
            return localStorage.getItem('page');
        } catch (e) {
            return null;  // ou você pode decidir retornar um valor padrão
        }
    }

    nomeCliente: string;

    public menuItems: any[];
    ps: any;
    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    hasRole(requiredRole: string): boolean {
        let userRole = localStorage.getItem('role');
        if (userRole === 'admin') {
            return true;
        };
        if (userRole === 'advisor') {
            if (requiredRole === 'client') {
                return true;
            }
        }
        return userRole === requiredRole;
    };

    sair() {
        localStorage.setItem('token', '');
        this.router.navigate(['/login']);
    };

    ngOnInit() {

        this.menuItems = ROUTES.filter(menuItem => menuItem);
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            this.ps = new PerfectScrollbar(elemSidebar);
        };

        this.nomeCliente = localStorage.getItem('first_name');

    }
    updatePS(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            this.ps.update();
        }
    }
    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
    expandOrCollapseMenu(id) {
        let parent = document.getElementById(id + "-p");
        let child = document.getElementById(id);
        parent.ariaExpanded = parent.ariaExpanded === "true" ? "false" : "true";
        child.style.height = child.style.height === "0px" || child.style.height === "" ? "100%" : "0";
    }
}
